import {
  DataTable,
  Table,
  TableBatchAction,
  TableBatchActions,
  TableBody,
  TableCell,
  TableContainer,
  TableExpandHeader,
  TableExpandRow,
  TableExpandedRow,
  TableHead,
  TableHeader,
  TableRow,
  TableSelectAll,
  TableSelectRow,
  TableToolbar,
  TableToolbarAction,
  TableToolbarContent,
  TableToolbarSearch,
  TableToolbarMenu,
  Link,
  Button,
  StructuredListWrapper,
  StructuredListHead,
  StructuredListRow,
  StructuredListBody,
  StructuredListCell

} from '@carbon/react';

import {
  TrashCan,
  Save,
  Download,
  PauseOutlineFilled,
  PlayFilled,
  Add
} from '@carbon/react/icons';

//import { useDispatch } from 'react-redux';

//import { spotActions } from '../../redux/actions';

import React, { useState, useEffect } from 'react';
import { Page } from '@/components/Page';

import moment from 'moment';
import 'moment/locale/de';

export const files_test = [
  {
    id:0,
    name: "Gameland Online spot",
    uri: "https://dev.micast.de/media.micast.de/spots/Big Cash 12 24 - GameLand Online.mp3",
  },
  {
    id:1,
    name: "Gameland Willkommen spot",
    uri:"https://dev.micast.de/media.micast.de/spots/Big Cash 12 23 - Willkommen im GameLand.mp3"
  }
];

export const rows_test = [
  {
    id: 0,
    name: "Werbespots Nord I",
    description: "Werbespots für alle Standorte im Norden",
    valid_from: "2022-01-01T10:00:00",
    valid_through: "2022-12-01T10:00:00",
    used_by: [
      {id: 201, label: "wandIT"},
      {id: 334, label: "m3-12847"}
    ],
    files: [
      {
        id:0,
        uri:"https://dev.micast.de/media.micast.de/spots/Big Cash 12 24 - GameLand Online.mp3",
      },
      {
        id:1,
        uri:"https://dev.micast.de/media.micast.de/spots/Big Cash 12 23 - Willkommen im GameLand.mp3",
      },
    ],
    timetable: [
      {
        file: 0,
        start: "2022-01-01T10:00:00",
        end: "2022-12-01T10:00:00",
        schedules: [
          {
            stat: "11:02",
            end: "23:59",
            weekdays: ["Mon-Sat"],
            interval: "3m",
          },
          {
            id: 1,
            stat: "13:02",
            end: "23:59",
            weekdays: ["Sun"],
            interval: "2h",
          }
        ],
      },
      {
        file: 1,
        start: "2022-01-01T10:00:00",
        end: "2022-12-01T10:00:00",
        schedules: [
          {
            stat: "10:04",
            end: "23:59",
            weekdays: ["Mon-Sat"],
            interval: "3m",
          },
          {
            stat: "12:04",
            end: "23:59",
            weekdays: ["Sun"],
            interval: "2h",
          }
        ],
      }
    ]
  },
  {
    id: 1,
    name: "Werbespots Nord II",
    description: "Werbespots für alle Standorte im Norden mit Werbung",
    valid_from: "2022-01-01T10:00:00",
    valid_through: "2022-15-01T10:00:00",
    used_by: [
    ],
    files: [
      {
        id:0,
        uri:"https://dev.micast.de/media.micast.de/spots/Big Cash 12 24 - GameLand Online.mp3",
      },
      {
        id:1,
        uri:"https://dev.micast.de/media.micast.de/spots/Big Cash 12 23 - Willkommen im GameLand.mp3",
      },
    ],
    timetable: [
      {
        file: 0,
        start: "2022-01-01T10:00:00",
        end: "2022-12-01T10:00:00",
        schedules: [
          {
            stat: "11:02",
            end: "23:59",
            weekdays: ["Mon-Sat"],
            interval: "3m",
          },
          {
            id: 1,
            stat: "13:02",
            end: "23:59",
            weekdays: ["Sun"],
            interval: "2h",
          }
        ],
      },
      {
        file: 1,
        start: "2022-01-01T10:00:00",
        end: "2022-12-01T10:00:00",
        schedules: [
          {
            stat: "10:04",
            end: "23:59",
            weekdays: ["Mon-Sat"],
            interval: "3m",
          },
          {
            stat: "12:04",
            end: "23:59",
            weekdays: ["Sun"],
            interval: "2h",
          }
        ],
      }
    ]
  }
];

const headers = [
  {
    key: "name",
    header: "Name",
  },
  {
    key: "description",
    header: "Beschreibung",
  },
  {
    key: "used_by",
    header: "in Verwendung",
  },
  {
    key: "active",
    header: "Status",
  },
];

const file_headers = [
  {
    key: "name",
    header: "Name",
  },
  {
    key: "media_control",
    header: "Aktion",
  },
];


export const Timetable = () => {

  //const dispatch = useDispatch();

  const [audio, setAudio] = useState(undefined);

  const [rows, setRows] = useState([]);
  const [rows_for_files, setRowsForFiles] = useState([]);
  const [row_playing_state, setRowIsPlaying] = useState(undefined);

  const triggerPlay = (id) => {
    console.info("play spot from ", id);
    if (row_playing_state === id) {
      setRowIsPlaying(undefined);
      if (audio) {
        audio.pause();
      }
      setAudio(undefined);
    } else {
      if (audio) {
        audio.pause();
      }

      let a = new Audio(files_test[id].uri);
      a.play();
      setAudio(a);
      setRowIsPlaying(id);
    }

  }

  const handleUploadMedia = () => {
    //dispatch(spotActions.showUploadMedia());
  };

  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    setRows(
      rows_test.map(row => {
        return {
          id: row.id.toString(),
          name: row.name,
          description: row.description,
          used_by: <div className="link_list">{row.used_by.map(ub => {return <Link key={ub.label}>{ub.label}</Link>}) }</div>,
          active: <Link disabled={!moment().isBetween(row.valid_from, row.valid_through)}>Aktiv</Link>,
        }
      })
    );

    setRowsForFiles(
      files_test.map(row => {
        return {
          id: row.id.toString(),
          name: row.name,
          uri: row.uri,
          media_control: <Button onClick={() => {triggerPlay(row.id)} } >{row_playing_state === row.id ? <PauseOutlineFilled /> : <PlayFilled/>}</Button>
        }
      })
    );
  }, []);

  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    setRowsForFiles(
      files_test.map(row => {
        return {
          id: row.id.toString(),
          name: row.name,
          uri: row.uri,
          media_control: <Button onClick={() => {triggerPlay(row.id)} } kind="ghost" iconDescription={row_playing_state === row.id ? "Stop Playback" : "Start Playback"} hasIconOnly renderIcon={row_playing_state === row.id ? PauseOutlineFilled : PlayFilled} />
        }
      })
    );
  }, [row_playing_state]);


  return (
    <Page pageTitle="Timetable bearbeiten" hasSideNav>
      <DataTable
        rows={rows}
        headers={headers}
        render={({
          rows,
          headers,
          getHeaderProps,
          getSelectionProps,
          getToolbarProps,
          getBatchActionProps,
          getRowProps,
          _onInputChange,
          _selectedRows,
          getTableProps,
          getTableContainerProps,
        }) => (
          <TableContainer
            title="Timetables"
            description="Liste der Timetable für Werbespots"
            {...getTableContainerProps()}>
            <TableToolbar {...getToolbarProps()}>
              <TableBatchActions {...getBatchActionProps()}>
                <TableBatchAction
                  renderIcon={TrashCan}
                  iconDescription="Delete the selected rows"
                >
                  Delete
                </TableBatchAction>
                <TableBatchAction
                  renderIcon={Save}
                  iconDescription="Save the selected rows"
                >
                  Save
                </TableBatchAction>
                <TableBatchAction
                  renderIcon={Download}
                  iconDescription="Download the selected rows"
                >
                  Download
                </TableBatchAction>
              </TableBatchActions>
              <TableToolbarContent>
                <TableToolbarSearch/>
                <TableToolbarMenu>
                  <TableToolbarAction>
                    Add row
                  </TableToolbarAction>
                  <TableToolbarAction>
                    Add header
                  </TableToolbarAction>
                </TableToolbarMenu>
              </TableToolbarContent>
            </TableToolbar>
            <Table {...getTableProps()}>
              <TableHead>
                <TableRow>
                  <TableExpandHeader />
                  <TableSelectAll {...getSelectionProps()} />
                  {headers.map((header, i) => (
                    <TableHeader key={i} {...getHeaderProps({ header })}>
                      {header.header}
                    </TableHeader>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map((row) => (
                  <React.Fragment key={row.id}>
                    <TableExpandRow {...getRowProps({ row })}>
                      <TableSelectRow {...getSelectionProps({ row })} />
                      {row.cells.map((cell) => (
                        <TableCell key={cell.id}>{cell.value}</TableCell>
                      ))}
                    </TableExpandRow>
                    <TableExpandedRow
                      colSpan={headers.length + 3}
                      className="cds--expanded-td">
                      <h6>Einstellungen</h6>
                      <StructuredListWrapper>
                        <StructuredListHead>
                          <StructuredListRow head>
                            <StructuredListCell head>Spot</StructuredListCell>
                            <StructuredListCell head>Zeitraum</StructuredListCell>
                            <StructuredListCell head>Steuerung</StructuredListCell>
                          </StructuredListRow>
                        </StructuredListHead>
                        <StructuredListBody>
                          <StructuredListRow>
                            <StructuredListCell noWrap>Gameland Online spot</StructuredListCell>
                            <StructuredListCell>von 10:00 bis 23:00 Uhr</StructuredListCell>
                            <StructuredListCell>
                                alle 5 Minuten<br/>
                                Montag, Donnerstag, Samstag-Sonntag
                            </StructuredListCell>
                          </StructuredListRow>
                          <StructuredListRow>
                            <StructuredListCell noWrap>Gameland Online spot</StructuredListCell>
                            <StructuredListCell>von 11:03 bis 23:00 Uhr</StructuredListCell>
                            <StructuredListCell>
                                alle 5 Minuten<br/>
                                Dienstag und Freitag
                            </StructuredListCell>
                          </StructuredListRow>
                        </StructuredListBody>
                      </StructuredListWrapper>
                      <br/>
                    </TableExpandedRow>
                  </React.Fragment>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      />

      <br/><br/>

      <DataTable
        rows={rows_for_files}
        headers={file_headers}
        render={({
          rows,
          headers,
          getHeaderProps,
          getSelectionProps,
          getToolbarProps,
          getBatchActionProps,
          getRowProps,
          _onInputChange,
          _selectedRows,
          getTableProps,
          getTableContainerProps,
        }) => (
          <TableContainer
            title="Medien"
            description="Liste verfügbaren Dateien"
            {...getTableContainerProps()}>
            <TableToolbar {...getToolbarProps()}>
              <TableBatchActions {...getBatchActionProps()}>
                <TableBatchAction
                  renderIcon={TrashCan}
                  iconDescription="Delete the selected rows"
                >
                  Delete
                </TableBatchAction>
                <TableBatchAction
                  renderIcon={Save}
                  iconDescription="Save the selected rows"
                >
                  Save
                </TableBatchAction>
                <TableBatchAction
                  renderIcon={Download}
                  iconDescription="Download the selected rows"
                >
                  Download
                </TableBatchAction>
              </TableBatchActions>
              <TableToolbarContent>
                <TableToolbarSearch/>
                <TableToolbarMenu>
                  <TableToolbarAction>
                    Add row
                  </TableToolbarAction>
                  <TableToolbarAction>
                    Add header
                  </TableToolbarAction>
                </TableToolbarMenu>
                <TableBatchAction hasIconOnly renderIcon={Add} onClick={() => handleUploadMedia()}/>
              </TableToolbarContent>
            </TableToolbar>
            <Table {...getTableProps()}>
              <TableHead>
                <TableRow>
                  <TableSelectAll {...getSelectionProps()} />
                  {headers.map((header, i) => (
                    <TableHeader key={i} {...getHeaderProps({ header })}>
                      {header.header}
                    </TableHeader>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map((row) => (
                  <React.Fragment key={row.id}>
                    <TableRow {...getRowProps({ row })}>
                      <TableSelectRow {...getSelectionProps({ row })} />
                      {row.cells.map((cell) => (
                        <TableCell key={cell.id}>{cell.value}</TableCell>
                      ))}
                    </TableRow>
                  </React.Fragment>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      />
    </Page>
  );
};
